import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import SettingsIcon from '@material-ui/icons/Settings';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Hidden from '@material-ui/core/Hidden';
import IconNoteAdd from '@material-ui/icons/NoteAdd';
import IconSync from '@material-ui/icons/Sync';
import IconViewList from '@material-ui/icons/ViewList';
import IconPerson from '@material-ui/icons/Person';
import IconAccBox from '@material-ui/icons/PowerSettingsNew';
import IconReport from '@material-ui/icons/Report';
import IconImport from '@material-ui/icons/ImportExport';
import IconEmail from '@material-ui/icons/Email';
import IconLast from '@material-ui/icons/LastPage';
import IconHist from '@material-ui/icons/History';
import IconDash from '@material-ui/icons/Dashboard';
import IconCal from '@material-ui/icons/CalendarToday';
import IconListAlt from '@material-ui/icons/ListAlt';
import IconFileCopy from '@material-ui/icons/FileCopy';

import Avatar from '@material-ui/core/Avatar';
import { userService, hasRole, roles } from '../services/user.service';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import red from '@material-ui/core/colors/red';
import withRoot from '../withRoot';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

const drawerWidth = 280;

const styles = theme => ({
    root: {
        display: 'flex',
        fontFamily: 'Roboto',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    cardHeader: {
    },
    appBar: {
        marginLeft: drawerWidth,
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
        },
    },
    menuButton: {
        marginRight: 20,
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 2,
    },
    avatar: {
        margin: 5,
        backgroundColor: theme.palette.primary.main
    },
    redAvatar: {
        margin: 5,
        color: '#fff',
        backgroundColor: red[500],
    },
    cardContent: {
        padding: theme.spacing.unit,
    },
    grow: {
        flexGrow: 1,
    },
    right: {
        textAlign: 'right',
    }
});


class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileOpen: false,
            title: '',
        };

        this.handleClick = this.handleClick.bind(this);
    }


    static displayName = Layout.name;

    handleDrawerToggle = () => {
        this.setState(state => ({ mobileOpen: !state.mobileOpen }));
    };
    handleDrawerClose = () => {
        this.setState(state => ({ mobileOpen: false }));
    };

    handleClick(e) {
        userService.logout();
        this.props.history.push("/");
    }

    render() {
        const { classes } = this.props;
        const technik = (
            <List>
                <ListItem button component={Link} to="/insemination-detail/null/new/null" onClick={this.handleDrawerClose}>
                    <ListItemIcon><IconNoteAdd /></ListItemIcon>
                    <ListItemText primary="Nová inseminácia" />
                </ListItem>
                <ListItem button component={Link} to="/insemination-list" onClick={this.handleDrawerClose}>
                    <ListItemIcon><IconSync /></ListItemIcon>
                    <ListItemText primary="Synchronizácia" />
                </ListItem>
                <ListItem button component={Link} to="/animal-list" onClick={this.handleDrawerClose}>
                    <ListItemIcon><IconViewList /></ListItemIcon>
                    <ListItemText primary="Zvieratá" />
                </ListItem>
                <ListItem button component={Link} to="/calving-report" onClick={this.handleDrawerClose}>
                    <ListItemIcon><IconReport /></ListItemIcon>
                    <ListItemText primary="Hlásenie teľnosti" />
                </ListItem>
                <Divider />
                <ListItem button component={Link} to="/settings" onClick={this.handleDrawerClose}>
                    <ListItemIcon><SettingsIcon /></ListItemIcon>
                    <ListItemText primary="Nastavenia" />
                </ListItem>
            </List>
        );
        const insem = ([
            { txt: 'Odoslať export', lnk: '/export-send', icn: <IconImport /> },
            { txt: 'Posledný export', lnk: '/export-last', icn: <IconLast /> },
            { txt: 'História', lnk: '/export-hist', icn: <IconHist /> },
            { txt: 'Žiadosti', lnk: '/modifdb-req', icn: <IconFileCopy /> },
        ].map(itm =>
            <ListItem key={itm.lnk} button component={Link} to={itm.lnk} onClick={this.handleDrawerClose}>
                <ListItemIcon>{itm.icn}</ListItemIcon>
                <ListItemText primary={itm.txt} />
            </ListItem>
        ));
        const pssr = ([
            { txt: 'Stav odovzdania dát', lnk: '/not-state', icn: <IconDash /> },
            { txt: 'Termíny', lnk: '/not-edit', icn: <IconCal /> },
            { txt: 'Prehľad činnosti', lnk: '/not-hist', icn: <IconHist /> },
            { txt: 'Odoslané maily', lnk: '/not-sent', icn: <IconEmail /> },
            { txt: 'Doplnenie chovu', lnk: '/update-db', icn: <IconListAlt /> },
        ].map(itm =>
            <ListItem key={itm.lnk} button component={Link} to={itm.lnk} onClick={this.handleDrawerClose}>
                <ListItemIcon>{itm.icn}</ListItemIcon>
                <ListItemText primary={itm.txt} />
            </ListItem>
        ));
        var user = userService.getUser();
        const drawer = (
            <div>
                {!userService.isLoggedIn() && <div>
                    <Card>
                        <CardHeader avatar={
                            <Avatar className={classes.redAvatar}><IconPerson /></Avatar>} title="Neprihlásený" />
                    </Card>
                </div>
                }
                {userService.isLoggedIn() &&
                    <Card>
                        <CardHeader className={classes.cardHeader}
                            avatar={
                                <Avatar className={classes.avatar}><IconPerson /></Avatar>
                            }
                            title={
                                <div>
                                    <Typography variant='subtitle2'>{user.fullName}</Typography>
                                    <Typography variant='body2'>{user.company}</Typography>
                                </div>
                            }
                        />
                        <CardContent className={classes.cardContent} >
                            <Divider />
                            {hasRole(roles.technik) && technik}
                            {hasRole(roles.insem) && insem}
                            {hasRole(roles.pssr) && pssr}
                            <Divider />
                            <List>
                                <ListItem button key="logout" href="#" onClick={this.handleClick}>
                                    <ListItemIcon><IconAccBox /></ListItemIcon>
                                    <ListItemText primary="Odhlásiť" />
                                </ListItem>
                            </List>
                        </CardContent>
                    </Card>
                }
            </div>
        );

        return (
            <div className={classes.root}>
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="Open drawer"
                            onClick={this.handleDrawerToggle}
                            className={classes.menuButton}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" color="inherit" noWrap>Reprodukcia HD{this.state.title}</Typography>
                        <div className={classes.grow} />

                        <Typography variant="caption" color="inherit" noWrap className={classes.right}>&copy; 2020 PSSR š.p.<br />ver.{process.env.REACT_APP_VERSION}</Typography>

                    </Toolbar>
                </AppBar>
                <nav className={classes.drawer}>
                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Hidden smUp implementation="css">
                        <Drawer
                            container={this.props.container}
                            variant="temporary"
                            anchor='left'
                            open={this.state.mobileOpen}
                            onClose={this.handleDrawerToggle}
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                        >
                            {drawer}
                        </Drawer>
                    </Hidden>
                    <Hidden xsDown implementation="css">
                        <Drawer
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                            variant="permanent"
                            open
                        >
                            {drawer}
                        </Drawer>
                    </Hidden>
                </nav>
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    {this.props.children}
                </main>
            </div>
        );
    }
}
Layout.propTypes = {
    classes: PropTypes.object.isRequired,
};


export default withRoot(withRouter(withStyles(styles)(Layout))); 



// WEBPACK FOOTER //
// ./src/components/Layout.js